'use strict';



import indexJson from './index.json'//with {type: 'json'};

export default function appController ($scope,$rootScope,$cookies, $window,$location,$state,GridsterService,MenuService,ResourcesDataService,MessagingService,AuthenticationService,KatalyoStateManager) {       
        $scope.CTRL='appController'; //active during LOGIN phase and immidiately after app.run !
        $scope.gsrvc = GridsterService;
        $scope.menu_service = MenuService;
		$scope.ksm = KatalyoStateManager; 
		if (!$rootScope.globals?.currentUser?.name)
				$rootScope.globals.currentUser = $cookies.getObject('currentUser') || null; 
		
        $scope.activity = { activityMessage : "" }; 
        $scope.ac = {      alerts : []       }; 
        
        $scope.currentState = $state.current.name;

        $scope.showNavbar = true;
        $scope.showSideMenu = false;
		
        let menuVisibility= $scope.ksm.addSubject( "menuVisibility", null);
        let menuVisibilityName = menuVisibility.subject.name;

        let dependent_field = "appCtrl"
        let observer = $scope.ksm.subscribe(menuVisibilityName,dependent_field,"menuVisibilityChanged",menu_visibility_process);
        let state = $scope.ksm.getState(menuVisibilityName);
        if (state.status=="ok" && state.state!==null) menu_visibility_process(state.state);
										
		let langCode = $rootScope.globals.currentUser?.langObj?.Code ?? 'en-GB'
										
		$scope.pageLabels = indexJson[langCode]
		$scope.config = indexJson['config']
		
		
		$scope.mergeObjects = (...objects) =>
			objects.reduce((acc, cur) => ({ ...acc, ...cur }));
			
        $scope.showActivity = function (msg) {
            setTimeout(function () {  
              $scope.activity.activityMessage = msg;   
             });
        };
		
	
        function menu_visibility_process (data)
        {
                $scope.showNavbar = data?.state?.navbar ?? $scope.showNavbar
                if (data?.state?.sideMenu!==undefined)  $scope.showSideMenu = data.state.sideMenu
                else $scope.showSideMenu = false
        }
		
		
        $scope.checkIfActive = function(ni)
        {
           return  ni.s_menus_Params.pagestate==$scope.menu_service.currentTarget && (ni.s_menus_Target==$scope.menu_service.currentPageId || ni.s_menus_Params.pagestate!='app.navbar.vpage')
        }
			
			
        $scope.multiSelectKeyUpDown = function (ev,id) 
		{
          var code = ev.keyCode || ev.which;
          var key = ev.key;
          var elem=$window.document.getElementById(id);
          if ((key==='p' || key==='P' || key==='b' || key==='B') && ev.ctrlKey) {
                ev.preventDefault();
                $scope.$broadcast("CtrlPBPressed",key);
          }
             
           /* if (code==13){
                //select element in focus    
              }
              //keyup
              if (code==38){  //move focus to next element
                 ev.preventDefault();
                 elem.next().focus(); 
              }
              //keydown
              if (code==40){//move focus to previous element   
                 ev.preventDefault();
                 elem.previous().focus(); 
              }  */
        }
       
};


appController.$inject = ['$scope','$rootScope','$cookies', '$window','$location','$state','GridsterService','MenuService','ResourcesDataService','MessagingService','AuthenticationService','KatalyoStateManager'];

export function homeNavbarCtrl($scope,$rootScope,$state) {
        //$scope.navbar = "/static/modules/0001_index/angularTemplates/navbar.html";
       $scope.CTRL='homeNavbarCtrl';
    };

homeNavbarCtrl.$inject = ['$scope','$rootScope','$state'];
    
export function errorNotFoundCtrl ($scope,$rootScope,$state,$stateParams) {
        //$scope.navbar = "/static/modules/0001_index/angularTemplates/navbar.html";
        //$scope.previousPage=$stateParams.fromState;
        $scope.params = $state.params;
        $scope.CTRL='errorNotFoundCtrl';
};

errorNotFoundCtrl.$inject = ['$scope','$rootScope','$state','$stateParams'];


export function errorCtrl ($scope,$rootScope,$state,$stateParams) {
     
        $scope.params = $state.params;
		//debugger
		if ($scope.params?.msg) {   
			if (typeof $scope.params.msg === 'string')
					$scope.msg = $scope.params.msg
			if (typeof $scope.params.msg === 'object')
					$scope.msg = JSON.stringify($scope.params.msg)
		}
        $scope.CTRL='errorCtrl';
};

errorCtrl.$inject = ['$scope','$rootScope','$state','$stateParams'];




export function homeCtrl($scope, $rootScope,$state,$cookies,$location,KatalyoStateManager,ProcessingService,MessagingService,CodesService,AuthenticationService,MenuService,ResourcesDataService,TaskDataService,GridsterService,SettingsService,$timeout,$stateParams){
        
     
        $scope.CTRL='homeCtrl';
        $rootScope.headTitle ="Katalyo | Home";
        $scope.currentState=$state.current.name;
        $scope.selectedApp = {'name':''}
        $scope.localVars = {};
        $scope.fd={};
        $scope.taskDefinition={};
        var lang = $rootScope.globals.currentUser.lang;
        $scope.currentUserFirstName=$rootScope.globals.currentUser?.first_name;
        $scope.extendedUser = angular.copy($rootScope.globals.currentUser.uep);
        $scope.resource={};
        $scope.resource_page_size=12;
        $scope.is_superuser =  $rootScope.globals.currentUser.is_superuser;
        $scope.appListParameters={iNumber:8}
        if ($scope.extendedUser==undefined) $scope.extendedUser = {};

        
        $scope.menu_service = MenuService;
	$scope.menu_service.clearSideMenu()
        let app_ref = $location.search().app_ref 
    
			
        //$scope.menu_service.loadDefaultMenu( !!app_ref )
	
		$scope.getCurrentEnvData = function(){
			return $rootScope?.globals?.environments[$rootScope?.globals?.currentEnv]
		}
		

		if ($stateParams.env) {
			//debugger
			sessionStorage.setItem("environment", $stateParams.env  )
			$rootScope.globals.currentEnv =  $stateParams.env 
		}
        
        $scope.gsrvc=GridsterService;
        $scope.gsrvc.resetBodyBgColor() 
        $scope.params={showAppList:1,subscribing:false};
        let tab= $location.search().tab
        if (tab!=undefined)  $scope.params.showAppList = tab
        //connect to metamask
       
        $scope.linkWeb3Wallet = function()
        {
                $scope.balance="";
                $scope.balance_ktlyo="";
                $scope.ktlyo_balance_ok = false;
                $scope.ktlyo_balance_msg = "";
                $scope.eth_address=null;
               
                        if ($scope.fd.eth_address!=null)
                        {
                                $scope.ktlyoAddressConnected=true;
                                var wei;
                                web3.eth.getBalance($scope.fd.eth_address, function (error, wei) {
                                        if (!error) {
                                        var balance = web3.utils.fromWei(wei, 'ether');
                                        $scope.balance = balance + " ETH";
                                        }
                                });
                                
                                var tokenAddress = "0x24E3794605C84E580EEA4972738D633E8a7127c8";
                                var tokenABI = [{"inputs":[],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"spender","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"spender","type":"address"}],"name":"allowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"approve","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"decimals","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"subtractedValue","type":"uint256"}],"name":"decreaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"addedValue","type":"uint256"}],"name":"increaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"renounceOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transfer","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"sender","type":"address"},{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transferFrom","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"}];
                               
                                var tokenInst = new web3.eth.Contract(tokenABI,tokenAddress);
                                
        
                                tokenInst.methods.balanceOf($scope.fd.eth_address).call().then(function (bal_raw) {
                                        var bal = web3.utils.fromWei(bal_raw, 'ether');
                                        if (bal<100)
                                        {
                                                $scope.ktlyo_balance_ok = false;
                                                $scope.ktlyo_balance_msg = "Insufficient balance";
                                        }else $scope.ktlyo_balance_ok = true;
                                        $timeout(function(){
                                                bal = parseFloat(bal).toLocaleString(navigator.language,{minimumFractionDigits:4,maximumFractionDigits:4});
                                                $scope.balance_ktlyo = bal+ " KTLYO";
                                                });
                                        });
                        
                         return true;
                }
              
                return false;
        }     
        
        $scope.getKtlyoBal = function()
        {
                //var tokenAddress = "0x24E3794605C84E580EEA4972738D633E8a7127c8";
                var eth_address = $rootScope.globals.currentUser.organisation.ETHAccount;
                
                //"0xc30c523a8eee10e36beb7a6d07c636e02762cb27";
                if (eth_address==null || eth_address.trim()=="")
                {
                    $scope.noKtlyoAddress=true;
                } else
                {
                        
                        $scope.linkedBlockchainAddress=true;
                        $scope.fd.eth_address = eth_address;
                        SettingsService.GetKtyloBalance(eth_address).then(function (data) {
                                let bal = data.data.balance;
                                
                                $rootScope.globals.currentUser.uep.ktlyo_block = data.data.block
                                $rootScope.globals.currentUser.uep.ktlyo_balance = bal

                                bal = bal.toLocaleString(navigator.language,{minimumFractionDigits:4,maximumFractionDigits:4});
                                $scope.balance_ktlyo =bal+" KTLYO" ;
                                $scope.block_ktlyo = "(at block "+data.data.block+ ")";
                                $scope.balance = data.data.balance_eth + " ETH (at block "+data.data.block_eth+ ")" ;
                                $scope.balanceChecked=true;
                               

                                $cookies.putObject('currentUser',$rootScope.globals.currentUser)
                        },function(error){
                                      
                                        MessagingService.addMessage(error.msg,'error');  
                        });
                }
        }
        
        $scope.mapKtlyoBal = function()
        {
                //var tokenAddress = "0x24E3794605C84E580EEA4972738D633E8a7127c8";
                var eth_address = $rootScope.globals.currentUser.organisation.ETHAccount;
               
                //"0xc30c523a8eee10e36beb7a6d07c636e02762cb27";
                if (eth_address==null || eth_address.trim()=="")
                {
                    $scope.noKtlyoAddress=true;
                } else
                {
                        
                       // $timeout(function(){
                                $scope.linkedBlockchainAddress=true;
                                $scope.fd.eth_address = eth_address;
                                $scope.balance_ktlyo = $rootScope.globals.currentUser.uep.ktlyo_balance?.toLocaleString(navigator.language,{minimumFractionDigits:4,maximumFractionDigits:4})+" KTLYO" ;
                                $scope.balance_ktlyo_num = $rootScope.globals.currentUser.uep.ktlyo_balance;
                                $scope.block_ktlyo = "(at block "+$rootScope.globals.currentUser.uep.ktlyo_block?.toLocaleString(navigator.language,{minimumFractionDigits:0,maximumFractionDigits:0})+ ")";
                                $scope.balanceChecked=true;
                                if ($scope.balance_ktlyo_num>=100) $scope.ktlyo_balance_ok = true;
                                else
                                {
                                        $scope.ktlyo_balance_ok = false;
                                        $scope.ktlyo_balance_msg = "Insufficient balance!";
                                }
                                
                         //       });
                        /*
                        SettingsService.GetKtyloBalance(eth_address).then(function (data) {
                                let bal = data.data.balance;
                                $scope.balance_ktlyo =bal+" KTLYO" ;
                                $scope.block_ktlyo = "(at block "+data.data.block+ ")";
                                $scope.balance = data.data.balance_eth + " ETH (at block "+data.data.block_eth+ ")" ;
                                $scope.balanceChecked=true;
                        },function(error){
                                      
                                        MessagingService.addMessage(error.msg,'error');  
                        });
                        */
                }
        }
        
        //$scope.getKtlyoBal();
        
        if ($scope.extendedUser.use_blockchain) $scope.mapKtlyoBal(); 
        
        $scope.$watch("fd.web3Connected",function(newValue,oldValue){
                if ($scope.fd.eth_address!=null && !$scope.linkedBlockchainAddress) $scope.linkWeb3Wallet();
        });
        
        
         $scope.changeWeb3WalletLinkStatus = function(status)
        {
          $scope.linkedBlockchainAddress=status;
          $scope.fd.web3Connected=status;
          $scope.fd.eth_address=null;
        }
        
        $scope.openedTaskInNewPage={localVars:null,taskDefinition:null};
    
        $scope.openTaskInNewPage=function(){
        
                $scope.openedTaskInNewPage = $scope.gsrvc.getTaskDataInNewPage();
        };
        
        
        $scope.saveBlockchainAccount=function(){
        
                SettingsService.SaveBlockchainAccount($scope.fd.eth_address).then(function (data) {
                                MessagingService.addMessage(data.data,'success');
                                //MenuService.LoadMenus($scope).then(function () { });
                                $rootScope.globals.currentUser.organisation.ETHAccount = $scope.fd.eth_address
                               
                                $scope.getKtlyoBal();
                                $scope.ktlyoAddressConnected=false; 
                        },function(error){
                                      
                                        MessagingService.addMessage(error.data,'error');  
                });        };
        
        $scope.localVars.loadedTasks=[];
        
        $scope.extendedUser.taskDefinitions = [];
        
      
      $scope.LoadTasks = function()
      {
        if ($scope.extendedUser.TaskListHome!=undefined)
        {
                $scope.localVars.loadedTasks.length = 0;
        
                for (var i=0;i<$scope.extendedUser.TaskListHome.length;i++)
                {
                    var localVars = {'isInlineTask':$scope.localVars.isInlineTask,'taskIndex':$scope.localVars.loadedTasks.length,'loadTaskDirect' : true,'taskId':$scope.extendedUser.TaskListHome[i].id,'outcomeId':0,'previousTask':0};
                    $scope.localVars.loadedTasks.push({'taskId':$scope.extendedUser.TaskListHome[i].id,'outcomeId':0,'previousTask':0,'localVars':localVars});
                      
                }
        }
      };
      //$scope.LoadTasks();
        //get apps
        $scope.getApps = function()
        {
                $scope.appListLoading=true;
                ResourcesDataService.GetResourceSubscriptions('application').then(function (data) {
                          
                        $scope.appListLoading=false;     
                        $scope.appList =data.data;

                },function(error){
                        $scope.appListLoading=false; 
                        MessagingService.addMessage(error.msg,'error');  
                });
          
        }
        
        $scope.getMyApps = function()
        {
            ResourcesDataService.GetResourceSubscriptions('application').then(function (data) {
                               
                          $scope.appList =data.data;
                                },function(error){
                              
                              MessagingService.addMessage(error.msg,'error');  
                            });
          
        }
        
        $scope.getUnsubscribedAppsFiltered = function(start,end)
        {
            ResourcesDataService.GetResourceSubscriptions('application').then(function (data) {
                               
                          $scope.appList =data.data;
                                },function(error){
                              
                              MessagingService.addMessage(error.msg,'error');  
                            });
          
        }
        
        /*
         $scope.getAllApps = function()
        {
          ResourcesDataService.getResourceDefByType(lang,'application').then(function (data) {
                               
                          $scope.appListFull =data.data;
                                },function(error){
                              
                              MessagingService.addMessage(error.msg,'error');  
                            });
        
        }*/
        
        $scope.getApps();
        
         $scope.loadApp = function(app)
        {
               app.loadingApp=true
               //get application params and load menus
				$rootScope.globals.app = app
               AuthenticationService.SetMenusForApp(app).then(function(data) {

                   //load default page
                   $scope.getDefaultPage(app,data);
                   
                 },function(error){
                  MessagingService.addMessage(error.msg,'error')
                  app.loadingApp=false
                 });
               
               
        };
        
        $scope.findLink = function (link_type,app) {
                for (let i=0;i<app.ResourceExtended.length;i++)  {
                        if (app.ResourceExtended[i].LinkType==link_type) return app.ResourceExtended[i].Resource2;
                }
                return null;
        }

        $scope.findLinkAll = function (link_type,app) {
                for (let i=0;i<app.ResourceExtended.length;i++)  {
                        if (app.ResourceExtended[i].LinkType==link_type) return app.ResourceExtended[i];
                }
                return null;
        }
   
        $scope.getDefaultPage = function (iapp,menu_loaded) 
		{
                let pageId,page,default_page_version
		
                if (iapp.uniqueId == 'ktlyo_builder') {//MIGOR	
                //if (iapp.app_type=='external') { //MIGOR 
                        if (iapp.ResourceExtended!=undefined) {
                                pageId = $scope.findLink("default-page",iapp)
                                let pageAll = $scope.findLinkAll("default-page",iapp)
                                default_page_version = pageAll?.Version
                                if (!default_page_version || !pageAll?.SelectVersionDirect) default_page_version = 0
                        }
                        if (pageId===undefined || pageId===null){    
                                MessagingService.addMessage('Default page is not set!','info');
                                MessagingService.addMessage('#'+iapp.Name+' application is not fully launched!','warning');
                                iapp.loadingApp=false
                        }  else  {   
                                ResourcesDataService.GetPublicPublishedResource(pageId).then(
									function(data) {
                                        let page = data.data;
                                        if (!menu_loaded || page.definition?.Target==undefined) 
												MessagingService.addMessage('#'+iapp.Name+' application is not fully launched!','warning');
                                        else MessagingService.addMessage('#'+iapp.Name+' application launched successfuly!','info');
                                        
                                        if (page.definition?.Target!==undefined)
                                        { 

                                         if (!default_page_version || !pageAll?.SelectVersionDirect) default_page_version = 0
					 $state.go(page.definition.Target  ,{ version:default_page_version,pageid: pageId, app_ref:iapp.uid})
                                        }
                                        else MessagingService.addMessage('Default page not loaded - target page definition error!','error');
                                        iapp.loadingApp=false 
                                },function(error){  
                                         MessagingService.addMessage(error.msg,'error');  
                                         iapp.loadingApp=false
                                });
                        }
                } 
                else { 	//  when APP_TYPE == INTERNAL
                        if (iapp.ResourceExtended!=undefined) page = $scope.findLinkAll("default-page",iapp);          
                        if (page===undefined || page===null){  
                                MessagingService.addMessage('Default page is not set!','info');
                                MessagingService.addMessage('#'+iapp.Name+' application is not fully launched!','warning');
                                iapp.loadingApp=false
                        } else  {
                               ResourcesDataService.GetPublishedResourceVersion(page.Resource2,'form',page.Version).then(
									function(data) {
                                        let pagePub = data.data;
                                        if (pagePub== null || pagePub==undefined || Object.keys(pagePub).length==0 || pagePub.Definition==undefined) {
                                                MessagingService.addMessage('Error loading application #'+iapp.Name +' => Page definition not found for page-id='+page.Resource2+', version='+page.Version,'error');
                                        } else {
                                                if (!menu_loaded)  MessagingService.addMessage('#'+iapp.Name+' application is not fully launched!','warning');
                                                else MessagingService.addMessage('#'+iapp.Name+' application launched successfuly!','info');
                                                default_page_version = page.Version
                                                if (!default_page_version || !page?.SelectVersionDirect) default_page_version = 0
                                                $state.go(pagePub.Definition?.ResourceExtended?.Target  ,{ pageid: pagePub.Definition?.uid,version:default_page_version, app_ref:iapp.uid,tab:$scope.params.showAppList});                                       
                                        }        
                                        iapp.loadingApp=false 
									},function(error){  
                                         MessagingService.addMessage(error.msg,'error');  
                                         iapp.loadingApp=false
                                });
                        }
                                
				}
        };
        
           /*
                ResourcesDataService.getResourceDefByType(lang,'application').then(function (data) {
                               
                          $scope.appListFull =data.data;
                                },function(error){
                              
                              MessagingService.addMessage(error.msg,'error');  
                            });
              
                
                 */
         $scope.subscribe_unsubscribe = function(app,index,sub_type)
        {
                app.subscribing=true;
                ResourcesDataService.ManageResourceSubscriptions(app,'application-'+app.app_type,sub_type).then(function (data) {
                               
                          MessagingService.addMessage(data.data.msg,'success');
                          app.subscribing=false;
                          $scope.appList[index].SubId=data.data.data.SubId;
                          $scope.appList[index].ActiveSub=data.data.data.ActiveSub;
                          
                          
                },function(error){
                              
                              if (error.data['msg']!=undefined) MessagingService.addMessage(error.data.msg,'error');
                              else MessagingService.addMessage(error.data,'error');
                              app.subscribing=false;
                });
                
        }
        

        $scope.getApplications = function(pageNumber,pageSize){
   
                
                $scope.resource_page_size = pageSize;
                $scope.resourceLoading=true;
            
                var filter=$scope.resource;
                 
                if ($scope.totalCount>0){
                    if (Math.ceil($scope.totalCount/pageSize)<newPage)
                    {
                      newPage = Math.ceil($scope.totalCount/pageSize);
                    }
                 }

        
                ResourcesDataService.getAppsFilteredBySubStatus(pageNumber,pageSize,filter,sub_status,lang).then(function(data) {
      
                                $scope.firstQuery=true;
                                $scope.appListUnsubscribed = data.data.results;
                                $scope.nextPage = data.data.next;
                                $scope.previousPage = data.data.previous;
                                $scope.totalItemCount=data.data.count;
                                $scope.currentPage=pageNumber;
                                $scope.numberOfPages = Math.ceil($scope.totalItemCount/pageSize);
                                
                                if (($scope.totalItemCount<=pageSize && $scope.resourceData.length>0) || $scope.totalItemCount==0) $scope.hideBtnMore = true;
                                else $scope.hideBtnMore=false;
                                
                                $scope.resourceLoading=false;
                                
                                },function(error){
       
                                 MessagingService.addMessage(error.msg,'error');
                                 $scope.resourceLoading=false;
                             });
        };
        $scope.loadMoreApplications = function(){
                $scope.resource_page_size = $scope.resource_page_size+12;
                $scope.getApplications(1,$scope.resource_page_size);        
                
        }
        
        
        $scope.getResourceDef = function(pageNumber,pageSize){
   
                
                $scope.resource_page_size = pageSize;
                $scope.resourceLoading=true;
            
                var filter=$scope.resource;
                 
                if ($scope.totalCount>0){
                    if (Math.ceil($scope.totalCount/pageSize)<newPage)
                    {
                      newPage = Math.ceil($scope.totalCount/pageSize);
                    }
                 }

        
                ResourcesDataService.getResourceDefFiltered(pageNumber,pageSize,filter,lang).then(function(data) {
      
                                $scope.firstQuery=true;
                                $scope.resourceData = data.data.results;
                                $scope.nextPage = data.data.next;
                                $scope.previousPage = data.data.previous;
                                $scope.totalItemCount=data.data.count;
                                $scope.currentPage=pageNumber;
                                $scope.numberOfPages = Math.ceil($scope.totalItemCount/pageSize);
                                
                                if (($scope.totalItemCount<=pageSize && $scope.resourceData.length>0) || $scope.totalItemCount==0) $scope.hideBtnMore = true;
                                else $scope.hideBtnMore=false;
                                
                                $scope.resourceLoading=false;
                                
                                },function(error){
       
                                 MessagingService.addMessage(error.msg,'error');
                                 $scope.resourceLoading=false;
                             });
        };
        $scope.loadMoreResource = function(){
                $scope.resource_page_size = $scope.resource_page_size+12;
                $scope.getResourceDef(1,$scope.resource_page_size);        
                
        }
        $scope.saveHomePage = function()
        {
          
           MenuService.saveHomePage($scope.extendedUser).then(function(data) {
                         $rootScope.globals.currentUser.uep = data.data;
                         $cookies.put('globals', $rootScope.globals);
                         $scope.extendedUser = $rootScope.globals.currentUser.uep;
                         $scope.LoadTasks();
                          MessagingService.addMessage(data.msg,'success');
                                },function(error){
                              
                              MessagingService.addMessage(error.msg,'error');  
                            });
        };

        

        if ($rootScope.globals.currentUser.uep?.Params?.Onboarding!='completed' && $rootScope.globals.currentUser.uep?.Params?.Onboarding!='stoppedOnClient') $state.go("app.nomenu.onboarding",{app_ref:undefined})
        /*
               ResourcesDataService.getResourceDefListByType(lang,'task').then(function(data) {
        
                                   $scope.taskList = data.data;
                                  
                               },function(error){
                                
                                  MessagingService.addMessage(error.msg,'error');
                                 
                            });
        */
        
    }
    
homeCtrl.$inject = ['$scope', '$rootScope','$state','$cookies','$location','KatalyoStateManager','ProcessingService','MessagingService','CodesService','AuthenticationService','MenuService','ResourcesDataService','TaskDataService','GridsterService','SettingsService','$timeout','$stateParams'];


export function marketCtrl($scope, $rootScope,$state,$cookies,$location,KatalyoStateManager,ProcessingService,MessagingService,CodesService,AuthenticationService,MenuService,ResourcesDataService,TaskDataService,GridsterService,SettingsService,$timeout,$stateParams){
        
     
        $scope.CTRL='marketCtrl';
        $rootScope.headTitle ="Katalyo | Marketplace";
        $scope.currentState=$state.current.name;
        $scope.selectedApp = {'name':''}
        $scope.localVars = {};
        $scope.fd={};
        $scope.taskDefinition={};
        var lang = $rootScope.globals.currentUser.lang;
        $scope.currentUserFirstName=$rootScope.globals.currentUser?.first_name;
        $scope.extendedUser = angular.copy($rootScope.globals.currentUser.uep);
        $scope.resource={};
        $scope.resource_page_size=12;
        $scope.is_superuser =  $rootScope.globals.currentUser.is_superuser;
        $scope.appListParameters={iNumber:8}
        if ($scope.extendedUser==undefined) $scope.extendedUser = {};
        
        if (!$scope.params) $scope.params={}

        $scope.params.showAppList=1
        $scope.menu_service = MenuService;
        $scope.menu_service.clearSideMenu() 

		$scope.showManifest = function (p_type) {
				$('#manifest').modal('show')
				$scope.modalAction='mainfest'
				//$scope.buildAppManifest()
		}
		
        
        $scope.getCurrentEnvData = function(){
                        return $rootScope?.globals?.environments[$rootScope?.globals?.currentEnv]
        }
                

        if ($stateParams.env) {
                        //debugger
                        sessionStorage.setItem("environment", $stateParams.env  )
                        $rootScope.globals.currentEnv =  $stateParams.env 
        }
        
        $scope.gsrvc=GridsterService;
        $scope.gsrvc.resetBodyBgColor() 

        //get apps
        $scope.getApps = function()
        {
                $scope.appListLoading=true;
                ResourcesDataService.GetPublishedPublicResourcesByType('app-manifest').then(function (data) {
                          
                        $scope.appListLoading=false;     
                        $scope.appList =data.data;

                },function(error){
                        $scope.appListLoading=false; 
                        MessagingService.addMessage(error.msg,'error');  
                });
          
        }
        
		
	//	appList: installed: []
		//		new: Array(1)
        
       
        $scope.getApps();
       
        $scope.appManifest=[]
        $scope.getAppManifest = function (resourceUid) {
                $scope.manifestLoading = true
                $scope.appManifest.length=0
                ResourcesDataService.GetPublishedResourceVersion(resourceUid,'app-manifest',0,'public').then(function(data) {
                               //debugger
                                $scope.manifestLoading = false
                                $scope.selectedApp=data.data
                                $scope.appManifest=data.data?.definition
                                $scope.params.selectedTab=1
                                },function(error){

                                    $scope.manifestLoading = false
                                    MessagingService.addMessage(error.msg,'error');
                                 
                });
      
        };

         $scope.showInstall = function(app)
        {
              //debugger
			   $scope.params.selectedApp=app
               $scope.params.showAppList=3
               $scope.getAppManifest(app.uid)
               
        };
		
        $scope.resourceInstalled = {}

        $scope.installResource = function()
        {
               $scope.installingResource = true
                ResourcesDataService.InstallResource($scope.selectedApp.id,$scope.selectedApp.uid,'application').then(
					function(data) {
                                $scope.installingResource = false
								$('#manifest').modal('hide')
                                $scope.resourceInstalled[$scope.selectedApp.uid]=true
                                MessagingService.addMessage(data.data,'success');
								$scope.getApps();
                     },function(error){
                            $scope.installingResource = false
                            MessagingService.addMessage(error.msg,'error'); 
                });
               
        };



        
    }
        
export function onboardingCtrl ($scope, $rootScope,$state,$cookies,MessagingService,MenuService,UserService,$timeout,$stateParams){

        $scope.CTRL='onboardingCtrl';
        $rootScope.headTitle ="Katalyo | Onboarding";
        $scope.currentState=$state.current.name;
        $scope.selectedApp = {'name':''}
        $scope.currentUserFirstName=$rootScope.globals.currentUser?.first_name;
        //$scope.extendedUser = angular.copy($rootScope.globals.currentUser.uep)
        
        $scope.menu_service = MenuService    
        $scope.menu_service.clearSideMenu()
  

        $scope.openProcess= function (evt,orderNumber) {
            // Get all elements with class="onboard-grid" and hide them
            document.querySelectorAll(".onboard-grid").forEach((content) => {
                content.style.display = "none";
            });

            // Get all elements with class="dot" and remove "dot-active" class from them.
            document.querySelectorAll(".dot").forEach((content) => {
                content.classList.remove("dot-active");
            });

            // Show the current tab, and add an "dot-active" class to the dotter.
            document.getElementById(orderNumber).style.display = "grid";
            document.getElementById('dot' + orderNumber).classList.add("dot-active");
        }

        
        $scope.closeProcess=function (status,gotoServer) {// Last button closes the whole process.
            
			if (! $rootScope.globals?.currentUser?.userid)  $state.go('app.navbar.home')		
			
            // update onboarding status to finish
            if  ($rootScope.globals.currentUser.uep==undefined)  $rootScope.globals.currentUser.uep={}
            if  ($rootScope.globals.currentUser.uep.Params==undefined)  $rootScope.globals.currentUser.uep.Params={}
            $rootScope.globals.currentUser.uep.Params.Onboarding=status
           
            //ToDo - send onboarding status to server 
            if (gotoServer)
            {
            UserService.saveUserExtended(status).then(function(data) {
                MessagingService.addMessage(data.data.msg,'success');
                 //put object in cookie
                
                $cookies.putObject('currentUser',  {
                    userid : $rootScope.globals.currentUser.userid,
                    username: $rootScope.globals.currentUser.username,
                    first_name: $rootScope.globals.currentUser.first_name,
                    last_name : $rootScope.globals.currentUser.last_name,
                   // environments: $rootScope.globals.currentUser.environments,
                    last_login:$rootScope.globals.currentUser.last_login,
                    is_superuser:$rootScope.globals.currentUser.is_superuser,
                    authdata: $rootScope.globals.currentUser.authdata,
                    auth_type: $rootScope.globals.currentUser.auth_type,
                    lang: $rootScope.globals.currentUser.lang,
                    langObj: $rootScope.globals.currentUser.langObj,
                    uep:{Params:{Onboarding:$rootScope.globals.currentUser.uep.Params.Onboarding}},
                   organisation: {id:$rootScope.globals.currentUser.organisation.id}
                });

                $state.go('app.navbar.home')
                },function(error){
                              
                MessagingService.addMessage(error.msg,'error');  
            });

            } else  $state.go('app.navbar.home')
            //go to home page
           

        }

       
        
        $scope.displayProcess=function (display) {
          document.querySelectorAll(".onboarding-container").forEach((content) => {
                content.style.display = display;
            }); 
        }
        // Don't show again double check.
        $scope.dontShow=function () {
            $scope.displayProcess('none')
            document.getElementById("noShow").style.display = "grid";
        }

        // Undo closes the whole modal.
        $scope.reopenProcess = function () {
            $scope.displayProcess('block')
            document.getElementById("noShow").style.display = "none";
        }

        // Close and don't show again
        $scope.dontShowTrue = function () {
           $scope.closeProcess('completed',true)
        }
     
}


 onboardingCtrl.$inject = ['$scope', '$rootScope','$state','$cookies','MessagingService','MenuService','UserService','$timeout','$stateParams'];

 
 export function demoCtrl ($scope, $rootScope,$state,$cookies,KatalyoStateManager,ProcessingService,MessagingService,CodesService,AuthenticationService,MenuService,ResourcesDataService,TaskDataService,GridsterService,$timeout,$stateParams){

        $scope.CTRL='demoCtrl';
        $rootScope.headTitle ="Katalyo | Demo";
        $scope.currentState=$state.current.name;
        //Login
}


 demoCtrl.$inject = ['$scope', '$rootScope','$state','$cookies','KatalyoStateManager','ProcessingService','MessagingService','CodesService','AuthenticationService','MenuService','ResourcesDataService','TaskDataService','GridsterService','$timeout','$stateParams'];

 
export function navbarCtrl($scope,$rootScope,$state,ResourcesDataService,CodesService,MenuService,$stateParams,$cookies,$timeout,MessagingService){


        $scope.CTRL='navbarCtrl';
        $scope.menu_service = MenuService;
        $scope.menus= {editMode: $scope.menu_service.getMenuEditMode()};
        $scope.logoutLoaded=false;
        $scope.navbarLoaded=true;
        
        $scope.cMenus=[];
        $scope.is_superuser =  $rootScope.globals.currentUser.is_superuser;
        $scope.currentPage = $state.current.name;
        $scope.currentNavbarId = $stateParams.navbar_id;
        $scope.menus.currentSideMenuId = $stateParams.sidemenu_id;
        var lang =  $rootScope.globals.currentUser.lang;
        $scope.deploydir = indexJson['config']['deploydir']

        $scope.getNavbarItems = function(lang)
        {
           
           $scope.menu_service.getNavbars(lang).then(function (data) {
          
            if ($scope.currentNavbarId==undefined || isNaN($scope.currentNavbarId) || $scope.currentNavbarId===0 || $scope.currentNavbarId==="")
            {
                $scope.currentNavbarId = $scope.getLinkNavbarByName($scope.currentPage);
            }
            
            
            
            if ($scope.menu_service.getMenuEditMode())
            {
              $scope.setEditNavbar($scope.currentEditNavbarId);
             
            }
            else
            {
              $scope.setNavbar($scope.currentNavbarId);
            }
            
             
          });
          
        };
        
       
     
       
       //get navbarId by page id
       $scope.getLinkNavbar = function(pageid) {
      
          return  $scope.menu_service.getPageNavbar(pageid,lang);
    
        };
      
      $scope.LoadLogout = function() {
        //$timeout(function(){
                $scope.logoutLoaded=true;
       // },1000);
        };
      //get navbarId by state name
      $scope.getLinkNavbarByName = function(currentStateName) {
      
          return  $scope.menu_service.getNavbarByTargetName(currentStateName,lang);
    
      };
     
      
    $scope.setSideMenu = function(menuId) {     
      $scope.menu_service.setSelectedSidemenu(menuId) ;
      //$scope.currentSideMenuId=menuId;
    };
      
      //SET current navbarId for editMode=false
      $scope.setNavbar = function(navbarId) {
        $scope.currentNavbarId = navbarId;
        $scope.menu_service.setCurrentNavbarId($scope.currentNavbarId,lang);
        
        //GET child menus
        $scope.cMenus = $rootScope.globals.currentUser.cMenus;
        
        if ($scope.menus.currentSideMenuId>0) $scope.setSideMenu($scope.menus.currentSideMenuId);
      //  $scope.getMenusForNavbar();
      };
    
    //GET navbar definition details
    $scope.getNavbarDetails = function(navbarId,index) {
      
      
       $scope.currentEditNavbarIndex=index;
      $scope.setEditNavbar(navbarId);
      
           //navbarItem.Users
                
    }
      
      //SET current navbarId for editMode=true
    $scope.setEditNavbar = function(navbarId) {
      $scope.menu_service.navbarSelected = false;
      $timeout(function(){
        $scope.currentEditNavbarId = navbarId;
        $scope.menu_service.setCurrentNavbarId(navbarId,lang);
       
      });
    }
      
     //generate children navbar right
              
     $scope.checkIfLast = function() {
     
      var rval=true;
     // if ($scope.menu_service.navbarItems != undefined) 
          for (var i=$scope.currentEditNavbarIndex+1; i<$scope.menu_service?.navbarItems?.length ;i++)
          {
           if ($scope.menu_service.navbarItems[$scope.currentEditNavbarIndex].s_menus_MenuPosition.id==$scope.menu_service.navbarItems[i].s_menus_MenuPosition.id)
            {
              rval= false;
            }
          }
       return rval;
     
    };
    
     $scope.checkIfFirst = function() {
     
      var rval=true;
      if ($scope.currentEditNavbarIndex==0) return rval;
      for (var i=$scope.currentEditNavbarIndex-1;i>=0;i--)
      {
       if ($scope.menu_service.navbarItems[$scope.currentEditNavbarIndex].s_menus_MenuPosition.id==$scope.menu_service.navbarItems[i].s_menus_MenuPosition.id)
        {
          rval= false;
        }
      }
       return rval;
     
    };
      
    $scope.moveNavbarLeft = function() {
     
      var element1 =  $scope.menu_service.navbarItems[$scope.currentEditNavbarIndex];
      var newIndex=$scope.currentEditNavbarIndex-1;
      while ($scope.menu_service.navbarItems[$scope.currentEditNavbarIndex].s_menus_MenuPosition.id!=$scope.menu_service.navbarItems[newIndex].s_menus_MenuPosition.id && newIndex>0)
      {
        newIndex=newIndex-1;
      }
      
      $scope.menu_service.navbarItems.splice($scope.currentEditNavbarIndex, 1);
      $scope.menu_service.navbarItems.splice(newIndex, 0, element1);
      $scope.currentEditNavbarIndex = newIndex;
     
    };
    $scope.moveNavbarRight = function() {
     
      var element2 =  $scope.menu_service.navbarItems[$scope.currentEditNavbarIndex];
      var newIndex=$scope.currentEditNavbarIndex+1;
      while ($scope.menu_service.navbarItems[$scope.currentEditNavbarIndex].s_menus_MenuPosition.id!=$scope.menu_service.navbarItems[newIndex].s_menus_MenuPosition.id && newIndex<$scope.menu_service.navbarItems.length-1)
      {
        newIndex=newIndex+1;
      }
      
      $scope.menu_service.navbarItems.splice($scope.currentEditNavbarIndex, 1);
      $scope.menu_service.navbarItems.splice(newIndex, 0, element2);
      $scope.currentEditNavbarIndex = newIndex;
    };
    
      $scope.setNavbarActive = function(navbarId) {
      if ($scope.navbarLoaded)
      {
      
      return navbarId==$scope.currentNavbarId ? "active" : "";
      }else $scope.setNavbarActive(navbarId);
    }
    
       $scope.newNavbar = function(){
           $scope.currentEditNavbarId = 0;
           $scope.menu_service.newNavbar(lang,'navbar');
       };            
    
        $scope.newChildNavbar = function(){
           $scope.currentEditNavbarId = 0;
           $scope.menu_service.newNavbar(lang,'navbarrightc');
       }; 
    
    $scope.activeLinkEditNavbar = function(navbar) {
      $scope.navbarEdit = null;
      if ($scope.navbarLoaded)
      {
      if ($scope.currentEditNavbarId!=undefined && $scope.currentEditNavbarId!=null)
      {
        $scope.navbarEdit = $scope.currentEditNavbarId;
      }
      return navbar==$scope.navbarEdit ? "active" : "";
      }else $scope.activeLinkEditNavbar(navbar);
    };
    
        $scope.saveNavbarOrder = function()
                
                {
     
                    $scope.menu_service.saveMenuOrder(lang,0).then(function(data) {
                                                                     
                                       MessagingService.addMessage(data.msg,'success');
                                    },function(error){    
                                    MessagingService.addMessage(error.msg,'error');
                              
                                 });
                  
                }; 
    
    $scope.gotoState=function(name,params)
    {
      $state.go(name,{navbarId: params});
      
    };

}

navbarCtrl.$inject = ['$scope', '$rootScope','$state','ResourcesDataService','CodesService','MenuService','$stateParams','$cookies','$timeout','MessagingService'];

export function menuCtrl($scope,$rootScope,$state,CodesService,MenuService,$stateParams,$cookies,MessagingService)
{
 
        $scope.CTRL='menuCtrl';
        $scope.menu_service = MenuService;
        $scope.menus={currentSideMenuId : $stateParams.sidemenu_id};
        var lang =  $rootScope.globals.currentUser.lang;
        $scope.activeLinkSidemenu = function(n) {
        
          return ($state.current.name.indexOf(n)>=0 ? "active" : "");
      };
      
      $scope.setSideMenu = function(menuId) {
       
        $scope.menu_service.setSelectedSidemenu(menuId) ;
        $scope.menus.currentSideMenuId=menuId;
      };
      

      //GET side menu definition details
      $scope.getSideMenuDetails = function(sidemenuId,index) {
       $scope.currentEditSideMenuIndex=index;
       $scope.currentEditSideMenuId = sidemenuId;
       $scope.setSideMenu(sidemenuId);
      }
      
      $scope.moveMenuUp = function() {
       
        var element = $scope.menu_service.selectedNavbar.SideMenus[ $scope.currentEditSideMenuIndex];
        $scope.menu_service.selectedNavbar.SideMenus.splice( $scope.currentEditSideMenuIndex, 1);
        $scope.menu_service.selectedNavbar.SideMenus.splice( $scope.currentEditSideMenuIndex-1, 0, element);
       $scope.currentEditSideMenuIndex--;
      }
      $scope.moveMenuDown = function() {
       
        var element = $scope.menu_service.selectedNavbar.SideMenus[ $scope.currentEditSideMenuIndex];
        $scope.menu_service.selectedNavbar.SideMenus.splice( $scope.currentEditSideMenuIndex, 1);
        $scope.menu_service.selectedNavbar.SideMenus.splice( $scope.currentEditSideMenuIndex+1, 0, element);
       $scope.currentEditSideMenuIndex++;
      }
      
         $scope.newSideMenu = function(){
             $scope.currentEditSideMenuId = 0;
             $scope.menu_service.newSideMenu(lang);
         }; 
       
       $scope.saveMenuOrder = function()
                  
                  {
       
                      $scope.menu_service.saveMenuOrder(lang,1).then(function(data) {
                                         
                                         $scope.menu_service.setSidemenuOrder(lang);                              
                                         MessagingService.addMessage(data.msg,'success');
                                         
                                      },function(error){    
                                      MessagingService.addMessage(error.msg,'error');
                                
                                   });
                    
                  };
      
       $scope.activeLinkSideByMenuId = function(menuItem) {
          
         return ($scope.menus.currentSideMenuId==menuItem.s_menus_id ? true : false);
         
      };
      
                   
       $scope.activeLinkSideEditByParams = function(params,menuItem) {
      
          
         return ($scope.currentEditSideMenuId==menuItem.s_menus_id ? true : false);
      
         
      };
      
      
      if ($scope.sideMenuId!=undefined && $scope.sideMenuId!="" && $scope.sideMenuId!=null)
      {
        $scope.setSideMenu($scope.sideMenuId);
      }


 }
 
 menuCtrl.$inject = ['$scope', '$rootScope','$state','CodesService','MenuService','$stateParams','$cookies','MessagingService'];

export function toolboxCtrl ($scope,GridsterService) {
         $scope.CTRL='toolboxCtrl';
       $scope.gsrvc = GridsterService;
}
toolboxCtrl.$inject =['$scope','GridsterService'];
export function taskToolboxCtrl ($scope,GridsterService) {
        
        $scope.CTRL='taskToolboxCtrl';
        $scope.gsrvc = GridsterService;
       
}
taskToolboxCtrl.$inject = ['$scope','GridsterService'];   

export function signupCtrl($scope,$http,$rootScope,$state,$timeout,vcRecaptchaService,RestApiService) {
        
       $scope.CTRL='signupCtrl';
       $rootScope.headTitle ="Katalyo | Sign up";
       $scope.signupSuccess = false;
       $scope.hideError="";
       var widgetId;
         $scope.signup = function(){
          
          // var language = $rootScope.globals.currentUser.lang;
           //if (language == undefined) language="en-GB";
           var language = "en-GB";
           $scope.dataLoading=true;
            
           let url = '../api/signup/';
                RestApiService.post(url,{'email':$scope.email,'captchaResponse':$scope.captchaResponse}).then(
                    response =>{
                          $timeout(function(){
                                    if (response.status === 200) {
                                          $scope.signupSuccess = true;
                                     } else {
                                         $scope.signupSuccess = false;
                                         $scope.errorMsg= response.data;
                                         vcRecaptchaService.reload(widgetId);  
                                    }
                                   $scope.checkingSignup=false;
                                   $scope.signupCheckDone = true;
                                   $scope.dataLoading=false;
                          });
                    },error=>{
                                $scope.dataLoading=false;
                                $scope.signupSuccess = false;
                                $scope.errorMsg=error;
                                vcRecaptchaService.reload(widgetId);        
                        
                }); 
    
         };

         
          $scope. onWidgetCreate = function(_widgetId){
                widgetId = _widgetId;
            };
          
          $scope.hideError = function(){
            $scope.errorMsg="";
          };
          
    }

 signupCtrl.$inject =   ['$scope','$http', '$rootScope','$state','$timeout','vcRecaptchaService','RestApiService'];
 
 
 
export function registerCtrl($scope,$cookies, $location, $http,$rootScope,$timeout,$state,$stateParams,AuthenticationService,RestApiService,MenuService,MessagingService) {
        
        $scope.CTRLNAME='registerCtrl';
        $rootScope.headTitle ="Katalyo | Register | Onboarding";
        
        //get data from hash and email
        $scope.signupkey=$stateParams.signupid;
        $scope.InvalidRequest=false;
        $scope.checkingSignup=true;
        $scope.signupOK=false;
        $scope.signupCheckDone=false;
        $scope.checkingEOSAccount = false;
        $scope.register={};
        
        let params = $stateParams
        params.env=undefined

        AuthenticationService.ClearCredentials()

        $scope.register.organisation_type="Personal";
        $scope.register.signup_key=$scope.signupkey;
        
        var weakRegularExp = new RegExp("^(?=.*[a-z])|(?=.*[A-Z])|(?=.*[0-9])|(?=.*[!@#\$%\^&\*\"\(\)\=\?\+\'<>;:,\-\._/\\\\])(?=.{8,})");   
        var midRegularExp = new RegExp("^((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))(?=.*[!@#\$%\^&\*\"\(\)\=\?\+\'<>;:,\-\._/\\\\])(?=.{8,})");           
        var strongRegularExp = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*\"\(\)\=\?\+\'<>;:,\-\._/\\\\])(?=.{8,})");  
       
        $scope.checkPassword = function(element)
        {  
          if (!strongRegularExp.test(element.$modelValue)) element.$setValidity("required",false);
        }
       
	   
        $scope.checkSignup = function(){
            let url = '../api/check-signup/';
            RestApiService.post(url,{'signupkey':$scope.signupkey})
			.then(response =>{
                   if (response.status === 200) {
                    $timeout(function(){               
                        $scope.signupOK = true;
                        $scope.checkingSignup=false;
                        $scope.signupCheckDone = true;
                       })  
                   } else {
                        $timeout(function(){    
                              $scope.signupOK = false;
                              $scope.checkingSignup=false;
                              $scope.signupCheckDone = true;
                              $scope.InvalidRequest = true;  
		              if (response.data)  $scope.errorMsg = response.data     
                        })  
                   }

               },(error) => {
			$timeout(function(){
                                $scope.signupOK = false;
                                $scope.checkingSignup=false;
                                $scope.signupCheckDone = true;
			})
	       })
			

        };
        
        
        $scope.fn_register = function(valid){
          
                if (!valid) return

                $scope.dataLoading = true
                let url = '../api/register/';
                RestApiService.post(url,$scope.register).then(response =>{
                
                        //$timeout(function(){
                                if (response.status === 200) { // if successful, bind success message to message	
									 //set user info
									$rootScope.globals.currentUser = response.data.data	
									sessionStorage.setItem("environment", $rootScope.globals.currentUser.uep.defaultenv  )
									//$location.search({'env': $rootScope.globals.currentUser.uep.defaultenv })
									$state.params.env = $rootScope.globals.currentUser.uep.defaultenv
                                                                        $state.transitionTo($state.current.name, $state.params, { notify: false,   location:'replace', inherit:true})

									AuthenticationService.SetCredentials(response.data.data, $scope.register.username,$scope.register.password);
												
									AuthenticationService.getOrgSchemas($rootScope.globals.currentUser?.organisation.id)
									.then(response2 => {	
											if (response2.data) 	
												$rootScope.globals.environments = response2.data.reduce((acc, obj) => {
															acc[obj.id.toString()] = obj;
															return acc;
												}, {});	

                                                                                     MessagingService.addMessage(response.data.msg,'success');
                                                                                     $scope.dataLoading = false
                                                                                             
                                                                                     $state.go("app.navbar.home", {env: $rootScope.globals.currentUser.uep.defaultenv }); //go to home page          
									}
									,(error) => {
                                                                                        $scope.errorMsg = error.data; 
                                                                                        MessagingService.addMessage(error.data,'error');
                                                                                        $scope.dataLoading = false    
                                                                        }) 

                                } else {  //response not 200!
								 
								      $timeout(function(){
											$scope.errorMsg = response.data; 
											//MessagingService.addMessage(response.data,'error'); //no message widget here available
											$scope.dataLoading = false  
							   
									});
	  
                                     
                             }
		      //}); //timeout!
		});
 			  
        };
        
        
        if ($scope.signupkey==undefined || $scope.signupkey=="") {
          $scope.signupCheckDone = true;
          $scope.checkingSignup=false;
        
        }else $scope.checkSignup(); 

        
    
				
       $scope.convertMemory = function(sizeInBytes){
          
            var convertedMemory={size:0,unit:''};
             if (sizeInBytes==0)
            {
              convertedMemory.size=sizeInBytes;
              convertedMemory.unit = "";
            }
            else if ((sizeInBytes/1024)<0.5)
            {
              convertedMemory.size=sizeInBytes;
              convertedMemory.unit = "Bytes";
            }
              else if ((sizeInBytes/1024)<1024)
              {
                convertedMemory.size=(sizeInBytes/1024).toFixed(2);
               
                convertedMemory.unit ="KB";
                
              }
              else if (sizeInBytes/1024<1024*1024)
              {
                convertedMemory.size=(sizeInBytes/1024/1024).toFixed(2);
               
                convertedMemory.unit ="MB";
              }
              else
              {
                convertedMemory.size=(sizeInBytes/1024/1024/1024).toFixed(2);
            
                convertedMemory.unit ="GB";
              }
          
            return convertedMemory;
        }; 
   
  
	$scope.convertTime = function (sizeInMicroSec) {

		var convertedTime = { size: 0, unit: '' };
		if (sizeInMicroSec == 0) {
			convertedTime.size = sizeInMicroSec;
			convertedTime.unit = "";
		}
		else if ((sizeInMicroSec / 1000) < 0.01) {
			convertedTime.size = sizeInMicroSec;
			convertedTime.unit = "microsec";
		}
		else if ((sizeInMicroSec / 1000) < 1000) {
			convertedTime.size = (sizeInMicroSec / 1000).toFixed(2);
			convertedTime.unit = "ms";
		}
		else if (sizeInMicroSec / 1000 / 1000 < 1000) {
			convertedTime.size = (sizeInMicroSec / 1000 / 1000).toFixed(2);
			convertedTime.unit = "s";
		}
		else if (sizeInMicroSec / 1000 / 1000 / 60 < 60) {
			convertedTime.size = (sizeInMicroSec / 1000 / 1000 / 60).toFixed(2);
			convertedTime.unit = "min";
		}
		else {
			convertedTime.size = (sizeInMicroSec / 1000 / 1000 / 60 / 60).toFixed(2);
			convertedTime.unit = "h";
		}

		return convertedTime;
	};    
          
}
    
registerCtrl.$inject = ['$scope','$cookies', '$location', '$http', '$rootScope','$timeout','$state','$stateParams','AuthenticationService','RestApiService','MenuService','MessagingService'];

export function unregisterCtrl($scope,$cookies, $location,$http,$rootScope,$timeout,$state,$stateParams,AuthenticationService,RestApiService,MenuService,MessagingService) {
        
        $scope.CTRLNAME='unregisterCtrl';
        $rootScope.headTitle ="Katalyo | Unregister | Onboarding";
        
        //get data from hash and email
        $scope.signupkey=$stateParams.signupid;
        $scope.InvalidRequest=false;
        $scope.checkingSignup=true;
        $scope.signupOK=false;
        $scope.signupCheckDone=false;
        $scope.checkingEOSAccount = false;
        $scope.register={};
        
        let params = $stateParams
        params.env=undefined

        AuthenticationService.ClearCredentials()

        $scope.register.organisation_type="Personal";
        $scope.register.signup_key=$scope.signupkey;
        
           
        $scope.checkSignup = function(){
            let url = '../api/check-signup/';
            RestApiService.post(url,{'signupkey':$scope.signupkey,'type':'unregister'})
                        .then(response =>{
                   if (response.status === 200) {
                    $timeout(function(){               
                        $scope.signupOK = true;
                        $scope.checkingSignup=false;
                        $scope.signupCheckDone = true;
                       })  
                   } else {
                        $timeout(function(){    
                              $scope.signupOK = false;
                              $scope.checkingSignup=false;
                              $scope.signupCheckDone = true;
                              $scope.InvalidRequest = true;  
                              if (response.data)  $scope.errorMsg = response.data     
                        })  
                   }

               },(error) => {
                        $timeout(function(){
                                $scope.signupOK = false;
                                $scope.checkingSignup=false;
                                $scope.signupCheckDone = true;
                        })
               })
                        

        };
        
        $scope.goto_registration= function()
        {
                 $state.go("app.register", {signupid: $scope.signupkey });
        }

        $scope.fn_unregister = function(){
          
                
                $scope.dataLoading = true
                let url = '../api/unregister/'
                RestApiService.post(url,$scope.signupkey).then(response =>{
                
                       
                                if (response.status === 200) { // if successful, bind success message to message        
                                 $timeout(function(){                                      
                                        $scope.dataLoading = false
                                        $scope.retMsg = response.data;                                                           
                                        $scope.unregisterOk = true;                                   
                                }); //timeout!
                                } else {  //response not 200!
                                    $scope.errorMsg = response.data; 
                                    MessagingService.addMessage(response.data,'error');
                                    $scope.dataLoading = false     
                                }
                    
                });
                          
        };
        
        
        if ($scope.signupkey==undefined || $scope.signupkey=="") {
          $scope.signupCheckDone = true;
          $scope.checkingSignup=false;
        
        }else $scope.checkSignup(); 

        
    
                                
      
}
    
unregisterCtrl.$inject = ['$scope','$cookies', '$location', '$http','$rootScope','$timeout','$state','$stateParams','AuthenticationService','RestApiService','MenuService','MessagingService'];
 
export function appSettingsCtrl($scope, $rootScope,$state,$cookies,$location,KatalyoStateManager,ProcessingService,MessagingService,CodesService,AuthenticationService,MenuService,ResourcesDataService,TaskDataService,GridsterService,SettingsService,$timeout,$stateParams){
        
     //debugger
		$scope.newgroup={}
        $scope.CTRL='appSettingsCtrl';
        $rootScope.headTitle ="Katalyo | Settings";
        $scope.currentState=$state.current.name;
        $scope.app = {'name':''}
        $scope.localVars = {};

        var lang = $rootScope.globals.currentUser.lang;

        $scope.resource={};
        $scope.resource_page_size=12;
		$scope.localVars.showList=1
					
		$scope.all_groups={} // holding all groups found
		$scope.all_page_groups={}
		$scope.all_menu_groups={} // holding all menu groups found					
		$scope.allchecked={} // check all groups 
		$scope.pageDict= {}		
		$scope.menuDict= {}		
		$scope.resourceDict= {}

		//default is page
		$scope.resourceDict=$scope.pageDict
		$scope.all_groups =  $scope.all_page_groups
        
        $scope.menu_service = MenuService;
		$scope.menu_service.clearSideMenu()
        let app_ref = $location.search().app_ref 
        let over = false
        if (!app_ref) over=true
        $scope.menu_service.loadDefaultMenu(over)
			
	
		$scope.show = function(what)// get-menus/(?P<lang>.+)/(?P<itype>.+)/(?P<appId>.+)/(?P<version>.+)
		{
			if (what=='page') {
			  $scope.localVars.showList=1
			  $scope.resourceDict = $scope.pageDict
			  $scope.all_groups =  $scope.all_page_groups
			}

			if (what=='admin') {
			  $scope.localVars.showList=2	 
			}
			
			if (what=='menu') {
			  $scope.localVars.showList=3
			  $scope.resourceDict = $scope.menuDict
			  $scope.all_groups =  $scope.all_menu_groups
			} 
		}
	  
		    
      $scope.saveApplication = function (isFormValid) 
	  {
        let app_data = {appId: $scope.app.uid, type: 'admins', admins: {users: $scope.localVars.adminUsers, groups: $scope.localVars.adminGroups}, version: $scope.app.version}
		if (isFormValid)
        {
                $scope.savingApp = true
                ResourcesDataService.saveApplication(app_data).then(
					function(data) {             
						$scope.savingApp = false  
						MessagingService.addMessage(data.data.msg,'success');
					},
					function(error){
						$scope.savingApp = false
						MessagingService.addMessage(error.msg,'error');
					})
       
        } else MessagingService.addMessage('App description is mandatory!','error');        

      };
	  
      
	
		$scope.getCurrentEnvData = function(){
			return $rootScope?.globals?.environments[$rootScope?.globals?.currentEnv]
		}
		
		if ($stateParams.env) {
			sessionStorage.setItem("environment", $stateParams.env  )
			$rootScope.globals.currentEnv =  $stateParams.env 
		}
        
        $scope.gsrvc=GridsterService;
        $scope.gsrvc.resetBodyBgColor() 
        $scope.params={showAppList:1,subscribing:false};
        let tab= $location.search().tab
        if (tab!=undefined)  $scope.params.showAppList = tab
           
        

        
		$scope.inputchanged = function(item, g)
		{
			item[g.gid].gid=g.gid
			item[g.gid].gname=g.gname
			
		}
	  
		$scope.addGroup = function(newgroup)
		{
			//'3': {'$checked': True, '$resourceid': 21, 'gid': 3, 'gname': 'josjednalang'
			$scope.showResourceList=false
			
			$scope.all_groups[newgroup.uid]=  {gid: newgroup.uid, gname: newgroup.name}
			
			for (const [key, resource] of Object.entries($scope.resourceDict)) {
					if (typeof resource === 'object' && resource !== null) {
						resource[newgroup.uid]= { '$checked': null, 'gid': newgroup.uid, 'gname': newgroup.name }
					}
			}
			 $timeout(function(){$scope.showResourceList=true })
		}
		
		
        $scope.getApps = function()// USED
        {
			//debugger
          $scope.appListLoading=true;
          ResourcesDataService.GetResourceSubscriptions('application').then(function (data) {       
                  $scope.appListLoading=false;     
                  $scope.appList =data.data;
          },function(error){
                  $scope.appListLoading=false; 
                  MessagingService.addMessage(error.msg,'error');  
          });
          
        }
        
        $scope.getMyApps = function()
        {
            ResourcesDataService.GetResourceSubscriptions('application').then(function (data) {        
                          $scope.appList =data.data;
                                },function(error){
                              MessagingService.addMessage(error.msg,'error');  
                            });  
        }
        
        $scope.getUnsubscribedAppsFiltered = function(start,end)
        {
            ResourcesDataService.GetResourceSubscriptions('application').then(function (data) {         
                          $scope.appList =data.data;
                                },function(error){     
                              MessagingService.addMessage(error.msg,'error');  
                            });
        }
        
 
        
        $scope.getApps();
		$scope.showResourceList = false

        
        $scope.findLink = function (link_type,app) {
                for (let i=0;i<app.ResourceExtended.length;i++)  {
                        if (app.ResourceExtended[i].LinkType==link_type) return app.ResourceExtended[i].Resource2;
                }
                return null;
        }

        $scope.findLinkAll = function (link_type,app) {
                for (let i=0;i<app.ResourceExtended.length;i++)  {
                        if (app.ResourceExtended[i].LinkType==link_type) return app.ResourceExtended[i];
                }
                return null;
        }
   
    

        $scope.getApplications = function(pageNumber,pageSize){ 
		
                $scope.resource_page_size = pageSize;
                $scope.resourceLoading=true;
            
                var filter=$scope.resource;
                 
                if ($scope.totalCount>0){
                    if (Math.ceil($scope.totalCount/pageSize)<newPage) {
                      newPage = Math.ceil($scope.totalCount/pageSize);
                    }
                 }

                ResourcesDataService.getAppsFilteredBySubStatus(pageNumber,pageSize,filter,sub_status,lang).then(
					function(data) {
                                $scope.firstQuery=true;
                                $scope.appListUnsubscribed = data.data.results;
                                $scope.nextPage = data.data.next;
                                $scope.previousPage = data.data.previous;
                                $scope.totalItemCount=data.data.count;
                                $scope.currentPage=pageNumber;
                                $scope.numberOfPages = Math.ceil($scope.totalItemCount/pageSize);
                                
                                if (($scope.totalItemCount<=pageSize && $scope.resourceData.length>0) || $scope.totalItemCount==0) $scope.hideBtnMore = true;
                                else $scope.hideBtnMore=false;
                                
                                $scope.resourceLoading=false;
                                
                    },function(error){
       
                                 MessagingService.addMessage(error.msg,'error');
                                 $scope.resourceLoading=false;
                             });
        };
		
		
        $scope.loadMoreApplications = function(){
                $scope.resource_page_size = $scope.resource_page_size+12;
                $scope.getApplications(1,$scope.resource_page_size);              
        }
        
        
        $scope.getResourceDef = function(pageNumber,pageSize){
   
                $scope.resource_page_size = pageSize;
                $scope.resourceLoading=true;
            
                var filter=$scope.resource;
                 
                if ($scope.totalCount>0){
                    if (Math.ceil($scope.totalCount/pageSize)<newPage) {
                      newPage = Math.ceil($scope.totalCount/pageSize);
                    }
                 }

        
                ResourcesDataService.getResourceDefFiltered(pageNumber,pageSize,filter,lang).then(
					function(data) {
                                $scope.firstQuery=true;
                                $scope.resourceData = data.data.results;
                                $scope.nextPage = data.data.next;
                                $scope.previousPage = data.data.previous;
                                $scope.totalItemCount=data.data.count;
                                $scope.currentPage=pageNumber;
                                $scope.numberOfPages = Math.ceil($scope.totalItemCount/pageSize);
                                
                                if (($scope.totalItemCount<=pageSize && $scope.resourceData.length>0) || $scope.totalItemCount==0) $scope.hideBtnMore = true;
                                else $scope.hideBtnMore=false;
                                
                                $scope.resourceLoading=false;
                                
                   },function(error){
       
                                 MessagingService.addMessage(error.msg,'error');
                                 $scope.resourceLoading=false;
                             });
        };
		
		
        $scope.loadMoreResource = function(){
                $scope.resource_page_size = $scope.resource_page_size+12;
                $scope.getResourceDef(1,$scope.resource_page_size);        
                
        }
		
		
        $scope.SaveResourceAccess = function()
        { 
			//remove entries with "checked= null"
			for (let key in $scope.resourceDict) {
				if ($scope.resourceDict.hasOwnProperty(key)) {
					let entry = $scope.resourceDict[key];
					for (let subKey in entry) {
						if (entry[subKey]["$checked"] == null && entry[subKey]['$resourceid']) {
							delete entry[subKey];
						}
					}
					if (entry['userCanWrite']==false) {
						//debugger    $scope.localVars.showList=1
						delete $scope.resourceDict[key]
						}
				}
			}


		if ($scope.localVars.showList==1) //saving admin-groups
            ResourcesDataService.SaveResourceAccess($scope.app, $scope.resourceDict).then(
				function(response) {
                          MessagingService.addMessage('Inserted:'  + response.data.inserted.length + ', Updated:' + response.data.updated.length + ' items','success');
                },function(error){
                              MessagingService.addMessage(error.msg,'error');  
             })
		
		if ($scope.localVars.showList==3) //saving menu-groups
            ResourcesDataService.SaveMenuAccess($scope.app, $scope.resourceDict).then(
				function(response) {
                          MessagingService.addMessage('Inserted:'  + response.data.inserted.length + ', Updated:' + response.data.updated.length + ' items','success');
                },function(error){
                              MessagingService.addMessage(error.msg,'error');  
             })
			 
			 
        }
		
		
		$scope.reloadPage = function()
		{
			$scope.selectedApp=null
			$state.reload()	
		}
		
		$scope.allChanged = function(g)
		{		
			for (const [key, resource] of Object.entries($scope.resourceDict)) {
					if (resource[g.gid] &&  $scope.allchecked[g.gid]!=undefined)  resource[g.gid].$checked = $scope.allchecked[g.gid]
			}
		}
		
		
		
		$scope.loadAppSettings =  function(app)
		{	
			 ResourcesDataService.GetResourceAccess(app).then(
			 
				response => {
                    if (response.status === 200 || response.status === 201 ) { 
						$scope.app = app
                       	$scope.resourceList= response.data.access_records	
						$scope.localVars.adminUsers= response.data.admin_users
						$scope.localVars.adminGroups= response.data.admin_groups
						$scope.allGroups = response.data.allgroups
						$scope.showResourceList = true
						
						//debugger
						for (const item of  app.ResourceExtended ) {
							if (item.LinkType=='app-menu')  $scope.localVars.appMenu = {id: item.Resource2, version: item.Version}
						}

						
						
						for (const [key, resource] of Object.entries($scope.resourceList)) {
							if (resource.itemSubType=="menu") $scope.localVars.appMenu = { 'id':key,'version':resource.version}
							if (resource.itemSubType!="page") delete $scope.resourceList[key] //delete non pages
							if (resource.version==null) delete $scope.resourceList[key] //delete if version is null (for examp. Home page) TODO - find another way to detect home page
							
							for (const [gid, access] of Object.entries(resource.$access)) {
									$scope.all_page_groups[gid]= { 'gid':gid, 'gname': access.$group_name }
							}	
						}
						
						//create resource dict
						for (const [key, item] of Object.entries($scope.resourceList)) {
							//create empty resource object if undefined
							if ($scope.resourceDict?.[item.id]==undefined) {	
								$scope.resourceDict[item.id]={}					
								for (const [group_id, resource] of Object.entries($scope.all_page_groups)) {//add all groups
										$scope.resourceDict[item.id][group_id] = {	
											'$checked': item.$access?.[group_id]?.e , '$resourceid': item.id, 'gid': resource.gid, 	'gname': resource.gname
										}
								}
							}
							
							$scope.resourceDict[item.id]['name']= item.itemName
							$scope.resourceDict[item.id]['type']= item.itemSubType
							$scope.resourceDict[item.id]['userCanWrite']= item.$userCanWrite ?? true
							$scope.resourceDict[item.id]['$resource_version']= item.version
							
						}
							
							// getMenusExe (menuId,type,version,refresh){
							$scope.menu_service.getMenusExe ($scope.localVars.appMenu.id,'a', $scope.localVars.appMenu.version,false).then( 
								(data) => {
								
									$scope.menuList= data.menus
									for (const  item of $scope.menuList) {
											$scope.all_menu_groups[item.auth_group_uid]= { 'gid':item.auth_group_uid, 'gname': item.auth_group_name}
									}
									//create resource dict
									for (const item of $scope.menuList) {
										if ($scope.menuDict?.[item.s_menus_id]==undefined) 	$scope.menuDict[item.s_menus_id]={}					
										for (const [group_uid, resource] of Object.entries($scope.all_menu_groups)) {
											//add all groups
											if ($scope.menuDict[item.s_menus_id][group_uid]==undefined) 	$scope.menuDict[item.s_menus_id][group_uid] = {	'$checked': null , '$resourceid': item.s_menus_id, 'gid': resource.gid, 	'gname': resource.gname			}
											if (item.auth_group_uid==group_uid)
													$scope.menuDict[item.s_menus_id][group_uid]['$checked'] = true
										}
										
										$scope.menuDict[item.s_menus_id]['name']= item.s_menus_Name
										$scope.menuDict[item.s_menus_id]['type']= item.s_menus_MenuType
										//$scope.menuDict[item.s_menus_id]['userCanWrite']= item?.$userCanWrite ?? true
										$scope.menuDict[item.s_menus_id]['userCanWrite']= true
										//$scope.menuDict[item.id]['$resource_version']= item.version
									}
								
							})
				
				
                    } else {
                       MessagingService.addMessage('Get resources in manifest!', 'info');     
                    }  
					
                }, 
				error => {
					       MessagingService.addMessage(error.msg,'error'); 
				}
				);
	}

        

   
        
}
    
appSettingsCtrl.$inject = ['$scope', '$rootScope','$state','$cookies','$location','KatalyoStateManager','ProcessingService','MessagingService','CodesService','AuthenticationService','MenuService','ResourcesDataService','TaskDataService','GridsterService','SettingsService','$timeout','$stateParams'];

 